import { ENTITY_TYPE_CONFIG } from "../constants";
import { IEntityBulkAssignmentState } from "../types";

export const getBulkAssignmentAnalyticsPayload = (
  state: IEntityBulkAssignmentState,
  extra: Record<string, string | number> = {},
) => {
  const entityType = state.entityType;
  const entityConfig = entityType ? ENTITY_TYPE_CONFIG[entityType] : null;

  return {
    organizationId: state.organizationId ?? "",
    entityType: entityType ?? "",
    entityId: state.entity?.public_id ?? "",
    entityName: state.entity?.name ?? "",
    entityLabel: entityConfig?.label ?? "",
    currentStep: state.currentStep ?? "",
    ...extra,
  };
};
